import React from 'react';
import { PropTypes } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, Grid, TableBody, TableContainer, Table, Divider } from '@mui/material';
import { WeightedTableRow } from '../../Table/WeightedTableRow';

export const RegistrationSummaryCard = ({ invoiceAddress, deliveryAddress, buyer, company, registrationDate }) => {
  const { t } = useTranslation();
  const regNumber = company?.regNumber;
  const doingBusinessAsName = company?.doingBusinessAsName;
  const legalForm = company?.legalForm;
  const countryCode = company?.countryCode;
  const buyerName = buyer?.name;
  const email = buyer?.email;
  const phoneNumber = buyer?.phoneNumber;

  return (
    <Card className="mb-3">
      <CardHeader
        title={doingBusinessAsName ? doingBusinessAsName : '?'}
        action={
          <TableContainer>
            <Table borderless size="sm">
              <TableBody>
                <WeightedTableRow
                  header={t('components.cards.actionSummary.registrationDate')}
                  value={registrationDate}
                />
              </TableBody>
            </Table>
          </TableContainer>
        }
      />
      <Divider />
      <CardContent>
        <Grid container spacing={3}>
          <Grid item>
            <TableContainer>
              <Table>
                <TableBody>
                  <WeightedTableRow
                    header={t('components.cards.actionSummary.orderer')}
                    value={buyerName ? buyerName : '-'}
                  />
                  <WeightedTableRow
                    header={t('components.cards.actionSummary.emailAddress')}
                    value={email ? email : '-'}
                  />
                  <WeightedTableRow
                    header={t('components.cards.actionSummary.phoneNumber')}
                    value={phoneNumber ? phoneNumber : '-'}
                  />
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Grid item>
            <TableContainer>
              <Table>
                <TableBody>
                  <WeightedTableRow
                    header={t('components.cards.actionSummary.registrationNumber')}
                    value={regNumber ? regNumber : '-'}
                  />
                  {legalForm && (
                    <WeightedTableRow
                      header={t('enums.legalForm.name')}
                      value={legalForm ? t(`enums.legalForm.values.${legalForm}`, legalForm) : '-'}
                    />
                  )}
                  <WeightedTableRow
                    header={t('components.cards.actionSummary.country')}
                    value={countryCode ? t(`enums.countryCode.values.${countryCode}`, countryCode) : '-'}
                  />
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Grid item>
            {invoiceAddress && (
              <TableContainer>
                <Table>
                  <TableBody>
                    <WeightedTableRow
                      header={t('components.cards.actionSummary.invoiceAddress')}
                      value={
                        <>
                          {invoiceAddress.streetAddress1},
                          {invoiceAddress.streetAddress2 && ` ${invoiceAddress.streetAddress2}, `}
                          {invoiceAddress.state && ` ${invoiceAddress.state}, `}
                          {invoiceAddress.zipCode} {invoiceAddress.city}
                        </>
                      }
                    />
                  </TableBody>
                </Table>
              </TableContainer>
            )}
            {deliveryAddress && (
              <TableContainer>
                <Table>
                  <TableBody>
                    <WeightedTableRow
                      header={t('components.cards.actionSummary.deliveryAddress')}
                      value={
                        <>
                          {deliveryAddress.streetAddress1},
                          {deliveryAddress.streetAddress2 && ` ${deliveryAddress.streetAddress2}, `}
                          {deliveryAddress.state && ` ${deliveryAddress.state}, `}
                          {deliveryAddress.zipCode} {deliveryAddress.city}
                        </>
                      }
                    />
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

RegistrationSummaryCard.propTypes = {
  invoiceAddress: PropTypes.object,
  deliveryAddress: PropTypes.object,
  buyer: PropTypes.object,
  company: PropTypes.object,
  registrationDate: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};
